import { useEffect, useState } from "react";

export const PALETTE_DEFAULT = { caricato: "#1D4ED8", liquidato: "#0E7490" };

/** valori correnti: letti dai grafici (Recharts) che vogliono un colore esadecimale */
export const PALETTE = { ...PALETTE_DEFAULT };

const EVENTO = "dbe-palette";

export function applicaPalette(p) {
  PALETTE.caricato = p?.caricato || PALETTE_DEFAULT.caricato;
  PALETTE.liquidato = p?.liquidato || PALETTE_DEFAULT.liquidato;
  const root = document.documentElement.style;
  root.setProperty("--c-caricato", PALETTE.caricato);
  root.setProperty("--c-liquidato", PALETTE.liquidato);
  window.dispatchEvent(new Event(EVENTO));
}

/** sottoscrive i cambi palette: serve solo dove il colore finisce in JS (grafici, svg) */
export function usePalette() {
  const [p, setP] = useState({ ...PALETTE });
  useEffect(() => {
    const h = () => setP({ ...PALETTE });
    window.addEventListener(EVENTO, h);
    return () => window.removeEventListener(EVENTO, h);
  }, []);
  return p;
}
